import React from 'react'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import * as defaultConst from '../../../constants/default_constants'
import * as linkConst from '../../../constants/link_constants'
import BoolField from 'bstrap-react-mobx-admin/field/bool'
import BoolInput from 'bstrap-react-mobx-admin/input/bool'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../../input/date'
import EmbededEntityInput from '../../input/embedded_entity'
import FlyprivaPricingsCopyModal from './flyprivate_pricings_copy_modal'
import moment from 'moment'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import RegionsInput from '../../input/regions'
import SelectInput from '../../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'

const FPrivatePricingEdit = observer(({ store, state, label, disabledEntityFromBatch, ...rest }) => {
  function _create4Label (found) {
    if (!found || !found.platform) {
      return ''
    }
    const platform = store.options.has('FlyPrivatePlatforms') &&
      store.options.get('FlyPrivatePlatforms').find((i) => i.value === found.platform)
    const typeSale = store.options.has('VodSaleTypes') &&
      store.options.get('VodSaleTypes').find((i) => i.value === found.type_sale)
    const tier = store.options.has('PricingTiers') &&
      store.options.get('PricingTiers').find((i) => i.value === found.tier)
    return `${(platform && platform.text) || found.platform} |
      ${(typeSale && typeSale.text) || found.type_sale} |
      ${(tier && tier.text) || found.tier}`
  }

  const _fpWarning = (store, row, record = null, checkParent = null) => {
    row = row || (record && toJS(record)) || {}
    if ((store.router && store.router.params && store.router.params.operation) ||
      (row.valid_to && moment().isAfter(moment(row.valid_to)))) {
      // inactive record, valid_to in the past
      return null
    }
    const recordID = store.cv.record && store.cv.record.has('id') && store.cv.record.get('id')
      ? parseInt(store.cv.record.get('id'))
      : null
    const parentID = store.cv.record && store.cv.record.has('parent_id') && store.cv.record.get('parent_id') > 0
      ? parseInt(store.cv.record.get('parent_id'))
      : null
    const countries = store.options.has('Countries') ? store.options.get('Countries') : []
    const rowRegions = row.regions && store.getRegionsFromCountries(row.regions, countries)
    const fpPricingsAll = store.options.has('flyprivate_all_pricings') ? store.options.get('flyprivate_all_pricings') : null
    const fpVideoPricingsAll = store.options.has('flyprivate_all_video_pricings') ? store.options.get('flyprivate_all_video_pricings') : null
    const pricings = checkParent
      ? row.flyprivate_platform_tier_pricing_id && parentID &&
        fpVideoPricingsAll.filter(i => parseInt(i.video_id) === parentID)
      : row.flyprivate_platform_tier_pricing_id && fpPricingsAll
        .filter(i => parseInt(i.flyprivate_platform_tier_id) === parseInt(row.flyprivate_platform_tier_pricing_id))
        .map(i => {
          const ii = Object.assign({}, i)
          Object.keys(defaultConst.VIDEO_QUALITY).map(q => {
            ii[q] = (ii[q + '_price'] === undefined || ii[q + '_price'] === null) ? false : true
          })
          return ii
        })

    if (!pricings || pricings.length <= 0) {
      // pricings are missing
      return store.__(checkParent
        ? 'Beware! Pricings are missing for parent record (series or season).'
        : 'Beware! Pricings are missing for the selected tier.')
    }

    const qualityChecked = {}
    Object.keys(defaultConst.VIDEO_QUALITY)
      .filter(q => row[q] !== undefined && row[q] !== false)
      .map(q => {
        qualityChecked[q] = {}
        rowRegions.map(j => {
          qualityChecked[q][j] = [{
            valid_from: moment(row.valid_from).clone(),
            valid_to: moment(row.valid_to).clone()
          }]
        })

        pricings
          .filter(i => i[q] === true)
          .map(p => {
            const pRegions = store.getRegionsFromCountries(p.regions, countries)
            const pFrom = moment(p.valid_from).clone()
            const pTo = moment(p.valid_to).clone()
            pRegions.filter(r => qualityChecked[q][r] !== undefined)
              .map(r => {
                qualityChecked[q][r]
                  .map((v, k) => {
                    if (!v || v === null) {
                      // skip
                    } else if (pFrom.isSameOrBefore(p.valid_from) && pTo.isSameOrAfter(p.valid_to)) {
                      qualityChecked[q][r][k] = null
                    } else if (
                      pFrom.isAfter(p.valid_from) && pFrom.isBefore(p.valid_to) &&
                      pTo.isAfter(p.valid_from) && pTo.isBefore(p.valid_to)
                    ) {
                      qualityChecked[q][r][k].valid_from = p.valid_from.clone()
                      qualityChecked[q][r][k].valid_to = pFrom.clone()
                      qualityChecked[q][r][k].push({
                        valid_from: pTo.clone(),
                        valid_to: p.valid_to.clone()
                      })
                    } else if (
                      pFrom.isSameOrBefore(p.valid_from) && pTo.isBefore(p.valid_to)
                    ) {
                      qualityChecked[q][r][k].valid_from = pTo.clone()
                      qualityChecked[q][r][k].valid_to = p.valid_to.clone()
                    } else if (
                      pFrom.isAfter(p.valid_from) && pTo.isSameOrAfter(p.valid_to)
                    ) {
                      qualityChecked[q][r][k].valid_from = p.valid_from.clone()
                      qualityChecked[q][r][k].valid_to = pFrom.clone()
                    }
                  })
                qualityChecked[q][r] = qualityChecked[q][r].filter(i => i !== null)
                if (qualityChecked[q][r] && qualityChecked[q][r].length <= 0) {
                  delete qualityChecked[q][r]
                }
              })
          })

        // drop if empty
        if (!qualityChecked[q] || Object.keys(qualityChecked[q]).length <= 0) {
          delete qualityChecked[q]
        }
      })

    // results for each quality
    const qualityResult = []
    Object.keys(defaultConst.VIDEO_QUALITY).map(q => {
      if (qualityChecked[q] !== undefined) {
        qualityResult.push(
          Object.keys(qualityChecked[q]).join(', ') + ' (' + defaultConst.VIDEO_QUALITY[q] + ')'
        )
      }
    })
    // return if some region/quality is missing
    return qualityResult && qualityResult.length > 0
      ? [store.__(checkParent
        ? 'Beware! Prices in parent (series or season) are missing for these regions'
        : 'Beware! Prices in selected "Pricing Tier" are missing for these regions')
        .concat(': ') + qualityResult.join(', ').concat('. '),
      qualityChecked]
      : true
  }

  const _EditForm = observer(({ record, state, updateFormField, errors, temporary, updateFormFieldT }) => {
    if (!temporary) {
      temporary = new Map()
    }

    const filterVodSaleTypes = i => {
      return !store.options.get('flyprivate_pricings').find(j =>
        temporary.has('pricing_select_platform') && j.platform === temporary.get('pricing_select_platform') &&
        j.type_sale === i.value)
    }

    const filterPricingTiers = i => {
      return !store.options.get('flyprivate_pricings').find(j =>
        temporary.has('pricing_select_platform') && j.platform === temporary.get('pricing_select_platform') &&
        j.type_sale === temporary.get('pricing_select_type') &&
        j.tier === i.value)
    }

    const { stageOneRestricted, stageTwoRestricted } = store.timeRestriction.checkSubentity(store, state)
    const dateRestriction = store.timeRestriction.pricings
    const isCommingSoon = (record && record.has('coming_soon_flag') && record.get('coming_soon_flag'))
    const tempPricing = store.router.params && store.router.params.operation &&
      store.router.params.operation === linkConst.BATCH_ACTION_PRICING_TEMP

    const warning1 = _fpWarning(store, null, record)
    const warning1info = warning1 && warning1 !== null && warning1 !== true && record.has('regions') && record.get('regions')
      ? <div className='col-xs-12'>
        <div className='alert alert-warning'>
          <p>{Array.isArray(warning1) ? warning1[0] : warning1}</p>
          <table className='table table-striped' style={Array.isArray(warning1)
            ? { margin: '1em 1em 0 1em' }
            : {}} >
            {Array.isArray(warning1)
              ? <tr>
                <th>{store.__('Region')}</th>
                <th>{store.__('Quality')}</th>
                <th>{store.__('From — to')}</th>
                <th>{store.__('Result')}</th>
              </tr>
              : null}
            {Array.isArray(warning1)
              ? Object.keys(warning1[1]).map(q => {
                return Object.keys(warning1[1][q]).map(r => {
                  return (<tr key={q}>
                    <td>{r}</td>
                    <td>{defaultConst.VIDEO_QUALITY[q]}</td>
                    <td>{warning1[1][q][r].map(v => {
                      return moment(v.valid_from).utc().format(defaultConst.DATE_FORMAT) + ' — ' +
                      moment(v.valid_to).utc().format(defaultConst.DATE_FORMAT)
                    })}</td>
                    <td>{store.__('is missing')}</td>
                  </tr>)})
              })
              : null}
          </table>
        </div>
      </div>
      : null

    const isParent = store.cv.record &&  store.cv.record.has('parent_id') && store.cv.record.get('parent_id') > 0
    const warning2 =  isParent ? _fpWarning(store, null, record, true) : ''
    const warning2info = warning2 && warning2 !== null && warning2 !== true && record.has('regions') && record.get('regions')
      ? <div className='col-xs-12'>
        <div className='alert alert-warning'>
          <p>{Array.isArray(warning2) ? warning2[0] : warning2}</p>
        </div>
      </div>
      : null

    return (
      <div className='row'>
        {state && Object.prototype.hasOwnProperty.call(state, 'lastSave') && store.lastSavedSubEntity &&
          Object.prototype.hasOwnProperty.call(store.lastSavedSubEntity, state.lastSave) &&
          <div className='col-xs-12'>
            <Button bsStyle='primary' onClick={() => store.loadLastSavedSubentity(state)} disabled={stageOneRestricted}>
              {store.__('+ Load data from the last saved item')}
            </Button><br />&nbsp;
          </div>
        }
        <div className='col-xs-12'>
          <div className='row'>
            <div className='col-xs-12 col-sm-6 col-md-4'>
              <SelectInput label={store.__('1. FlyPrivate Platform')} attr={'pricing_select_platform'} record={temporary}
                onChange={updateFormFieldT} optionsrecord={store.options} disabled={stageOneRestricted}
                optionsattr={'FlyPrivatePlatforms'}
                labelattr='text' valueattr='value' errors={errors} />
            </div>
            {temporary.has('pricing_select_platform') && temporary.get('pricing_select_platform') &&
              <div className='col-xs-12 col-sm-6 col-md-4'>
                <SelectInput label={store.__('2. Sale Type')} attr={'pricing_select_type'} record={temporary}
                  onChange={updateFormFieldT} optionsrecord={store.options} disabled={stageOneRestricted}
                  optionsattr={'VodSaleTypes'} valueFilterFc={filterVodSaleTypes}
                  labelattr='text' valueattr='value' errors={errors} />
              </div>}
            {temporary.has('pricing_select_type') && temporary.get('pricing_select_type') &&
              <div className='col-xs-12 col-sm-6 col-md-4'>
                <SelectInput label={store.__('3. Pricing Tier')} attr={'pricing_select_tier'} record={temporary}
                  onChange={updateFormFieldT} optionsrecord={store.options} disabled={stageOneRestricted}
                  optionsattr={'PricingTiers'} valueFilterFc={filterPricingTiers}
                  labelattr='text' valueattr='value' errors={errors} />
              </div>}
          </div>
          <SelectInput label={tempPricing
            ? store.__('New temporary pricing (select filters from 1. to 3.)')
            : store.__('Pricing ID (select filters from 1. to 3.)')}
          attr={'flyprivate_platform_tier_pricing_id'} record={record}
          onChange={updateFormField} optionsrecord={store.options} optionsattr={'flyprivate_pricings'} disabled
          labelattr={_create4Label} valueattr='id' errors={errors} />

          {tempPricing && record.get('flyprivate_platform_tier_pricing_id') &&
            <div>
              <div className='alert alert-warning'><h4>Warning!</h4>
              Choose optional <strong>Pricing to temporarily interrupt </strong>
              which will be interrupted by <strong>New temporary pricing</strong>, otherwise all <strong>{
                  store.options.has('FlyPrivatePlatforms') && temporary.has('pricing_select_platform') && temporary.get('pricing_select_platform') &&
              store.options.get('FlyPrivatePlatforms').find((i) => i.value === temporary.get('pricing_select_platform')).text} | {
                  store.options.has('VodSaleTypes') && temporary.has('pricing_select_type') && temporary.get('pricing_select_type') &&
              store.options.get('VodSaleTypes').find((i) => i.value === temporary.get('pricing_select_type')).text} </strong>
              pricings will be interrupted with the selected parameters (valid from/valid to/regions) on the selected films with the same regions.
              </div>
              <SelectInput label={store.__('Pricing to temporarily interrupt (optional)')}
                attr={'flyprivate_pricing_to_interrupt'} record={record}
                onChange={updateFormField} optionsrecord={store.options} optionsattr={'flyprivate_all_tiers'}
                valueFilterFc={temporary.get('pricing_select_platform')
                  ? i => i.type_sale !== temporary.get('pricing_select_type') ||
                    i.platform !== temporary.get('pricing_select_platform') ||
                    parseInt(i.id) === parseInt(record.get('flyprivate_platform_tier_pricing_id'))
                  : null}
                labelattr={_create4Label} valueattr='id' errors={errors} /><br />
            </div>}
          <DateInput label={store.__('valid from')} attr={'valid_from'} showTime={true}
            disabled={stageOneRestricted} minDate={dateRestriction.valid_from.minDate}
            record={record} onChange={updateFormField} errors={errors} />
          <DateInput label={store.__('valid to')} attr={'valid_to'} showTime={true} validToTime={true}
            disabled={stageTwoRestricted} minDate={dateRestriction.valid_to.minDate}
            record={record} onChange={updateFormField} errors={errors} />
          <BoolInput label={store.__('UTC time')} disabled={stageOneRestricted}
            attr={'utc_flag'} record={record} onChange={updateFormField} errors={errors} />
          <RegionsInput label={store.__('regions')} attr={'regions'} disabled={stageOneRestricted}
            record={record} onChange={updateFormField} errors={errors} tzInfo={true}
            optionsrecord={store.options} optionsattr={'Countries'} />
          <BoolInput type='number' label={store.__('Mobile quality')} disabled={stageOneRestricted || isCommingSoon}
            attr={'quality_mobile'} record={record} onChange={updateFormField} errors={errors} />
          <BoolInput type='number' label={store.__('SD quality')} disabled={stageOneRestricted || isCommingSoon}
            attr={'quality_sd'} record={record} onChange={updateFormField} errors={errors} />
          <BoolInput type='number' label={store.__('HD quality')} disabled={stageOneRestricted || isCommingSoon}
            attr={'quality_hd'} record={record} onChange={updateFormField} errors={errors} />
          <BoolInput type='number' label={store.__('UHD quality')} disabled={stageOneRestricted || isCommingSoon}
            attr={'quality_uhd'} record={record} onChange={updateFormField} errors={errors} />
          <BoolInput label={store.__('Coming soon')} disabled={stageOneRestricted}
            attr={'coming_soon_flag'} record={record} onChange={updateFormField} errors={errors} />
          <BoolInput label={store.__('Prior item')} disabled={stageOneRestricted}
            attr={'prior_flag'} record={record} onChange={updateFormField} errors={errors} />
        </div>
        {warning1info || warning2info ? <div className='col-xs-12'><hr /></div> : null}
        {warning1info}
        {warning2info}
      </div>
    )
  })

  const attr = 'flyprivate_video_pricing'
  const fpPricings = store.options.get('flyprivate_pricings')
  const fppAttr = 'flyprivate_platform_tier_pricing_id'
  const isSubent = store.cv && store.cv.subentities && store.cv.subentities.FPPricingsCopy

  return (
    <React.Fragment>
      <EmbededEntityInput
        store={store}
        attr={attr}
        state={state}
        disabled={!!disabledEntityFromBatch}
        items={store.cv.record.get(attr)}
        items2add={fpPricings}
        edit_title={store.__('edit FlyPrivate pricing item')}
        add_title={store.__('add FlyPrivate pricing item')}
        fields={[
          (attr, row) => {
            if (store.router && store.router.params && store.router.params.operation) {
              return null
            }
            const isParent = store.cv.record && store.cv.record.has('parent_id') && store.cv.record.get('parent_id') > 0
            const warning1 = _fpWarning(store, row)
            const warning2 =  isParent ? _fpWarning(store, row, null, true) : ''
            const isOK = Array.isArray(warning1) || Array.isArray(warning2)
              ? (Array.isArray(warning1) ? warning1[0] : '') + (Array.isArray(warning2) ? warning2[0] : (warning2 || ''))
              : warning1
            // traffic light info
            return (<OverlayTrigger placement={'right'} overlay={
              <Tooltip>{isOK === true
                ? store.__('OK')
                : (isOK === null ? store.__('Inactive record') : isOK)}
              </Tooltip>}>
              <span className={isOK === true
                ? 'label label-success'
                : (isOK === null ? 'label label-default' : 'label label-warning')}
              style={{ position: 'relative', top: '0.6em' }}>
                <i className={isOK === true || isOK === null
                  ? 'glyphicon glyphicon-ok-sign'
                  : 'glyphicon glyphicon-alert'} />
              </span>
            </OverlayTrigger>)
          },
          (attr, row) => (<TextField attr={attr} val={row[attr]} />),
          (attr, row) => (<OptionsField attr={attr} val={row[fppAttr]} options={fpPricings} valueattr='id' labelattr={
            (val) => store.options.has('FlyPrivatePlatforms')
              ? ((store.options.get('FlyPrivatePlatforms').find(i => i.value === val.platform) || {}).text) || val.platform
              : 'platform'
          } />),
          (attr, row) => (<OptionsField attr={attr} val={row[fppAttr]} options={fpPricings} valueattr='id' labelattr={
            (val) => store.options.has('VodSaleTypes')
              ? ((store.options.get('VodSaleTypes').find((i) => i.value === val.type_sale) || {}).text) || val.type_sale
              : 'type_sale'
          } />),
          (attr, row) => {
            const gotoTier = ({ text }) => (
              <a title={store.__('Click to open pricing tier.') + store.__(' ID: ') + row.flyprivate_platform_tier_pricing_id}
                href='javascript:void(0)' onClick={() => {
                  store.beforeEditViewExit() && store.router.goTo(
                    store.views.entity_detail,
                    { entityname: 'flyprivate_pricing', id: row.flyprivate_platform_tier_pricing_id }, store, {})
                }}>
                <span className='glyphicon glyphicon-share-alt' />&nbsp;{text}
              </a>
            )
            const gotoTierHasRight = store.hasRight(linkConst.LINK_PRICING) ? gotoTier : null
            return <OptionsField
              attr={attr}
              val={row[fppAttr]}
              options={fpPricings}
              valueattr='id'
              labelattr={
                (val) => store.options.has('PricingTiers')
                  ? ((store.options.get('PricingTiers').find((i) => i.value === val.tier) || {}).text) || val.tier
                  : 'tier'
              }
              Component={gotoTierHasRight}
            />
          },
          (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.valid_to} showTime />),
          (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.valid_from} showTime />),
          (attr, row) => (<BoolField attr={attr} val={row[attr]} />),
          (attr, row) => (<TextField attr={attr} val={row[attr]} />),
          (attr, row) => (<BoolField attr={attr} val={row[attr]} />),
          (attr, row) => (<BoolField attr={attr} val={row[attr]} />),
          (attr, row) => (<BoolField attr={attr} val={row[attr]} />),
          (attr, row) => (<BoolField attr={attr} val={row[attr]} />),
          (attr, row) => (<BoolField attr={attr} val={row[attr]} />),
          (attr, row) => (<BoolField attr={attr} val={row[attr]} />)
        ]}
        rowId={(row) => null}
        EditForm={_EditForm}
        copyModalToggle={(store.cv.record.get(attr) && store.cv.record.get(attr).length) || !isSubent
          ? null
          : store.toggleFPPricingsCopyModal}
        {...rest}
      />
      <FlyprivaPricingsCopyModal store={store} />
    </React.Fragment>
  )
})
export default FPrivatePricingEdit
